import { createStyles, Flex, Group, Menu } from '@mantine/core';
import { Button, IconButton, Text } from '@repo/foundations';

import { pluralize } from '@repo/common/utils';

interface QueryHeaderProps {
	lookBackDays: number;
	setLookBackDays: (lookBackDays: number) => void;
	close: () => void;
}

const useStyles = createStyles((theme) => ({
	buttons: {
		gap: theme.spacing.xs,
	},
	grow: {
		flexGrow: 1,
	},
	wrapper: {
		width: '100%',
		alignItems: 'center',
		paddingRight: theme.spacing.lg,
	},
}));

export function QueryHeader({
	lookBackDays,
	setLookBackDays,
	close,
}: QueryHeaderProps) {
	const { classes } = useStyles();

	return (
		<Flex className={classes.wrapper}>
			<Text size="lg" fw={600} className={classes.grow}>
				Query
			</Text>
			<Flex className={classes.buttons} mr="sm">
				<Menu>
					<Menu.Target>
						<Button variant="default" rightIconName="selector">
							Last {lookBackDays} {pluralize('day', lookBackDays)}
						</Button>
					</Menu.Target>
					<Menu.Dropdown>
						{[1, 7, 30].map((option) => (
							<Menu.Item key={option} onClick={() => setLookBackDays(option)}>
								{option} {pluralize('day', option)}
							</Menu.Item>
						))}
					</Menu.Dropdown>
				</Menu>
			</Flex>
			<Group spacing={4} ml="sm">
				<IconButton
					variant="tertiary"
					iconName="x"
					size="md"
					tooltip="Close"
					onClick={close}
				/>
			</Group>
		</Flex>
	);
}
